import React from 'react';

class PrimaryHero extends React.Component {

  render() {
    const { children } = this.props;

    return (
      <div id="primary-hero" className="w-100 bg-dark text-white px-lg-5 py-4 py-lg-5">
        <div className="container-fluid">
          <div className="container mb-lg-4 pb-lg-5">
            {children}
          </div>
        </div>
      </div>
    );
  }

}

export default PrimaryHero;
